(function() {
	'use strict';

	angular.module('quantixApp').controller(
			'UserTrackerController', UserTrackerController);

	UserTrackerController.$inject = ['$scope','$http','UserTrackerService','query','baseRequest','$timeout'];

	function UserTrackerController($scope,$http,UserTrackerService,query,baseRequest,$timeout) {
		var userTrackerGrid = '';
		$scope.userTrackerGridData = {

				dataProvider : [],
				delegate : $scope

			};
		$scope.finalData = {};
		var url='api/userTracker/getUserTrackerList';
		
		var vm = this;
		$scope.userAndLoginList = {};
		vm.clientNameModel = [];
		vm.loginNameModel = [];
		$scope.client = [];
		$scope.login=[];
		$scope.finData =[];
		$scope.userTrackerGrid = '';
		
//		$scope.filterPageSortChangeHandler = function (evt1) {
//            var grid = evt1.target;
//            console.log(evt1.userTrackerDTO);
//            query(evt1.filter,url).then(function (data) {
//                grid.setPreservePager(true);
//                grid.setDataProvider(data.userTrackerDTO);
//                if(data.userTrackerDTO.length>0){
//                    grid.setTotalRecords(data.totalCount);}else{
//                   	 grid.setTotalRecords(0);
//                    }
//                grid.validateNow();
//            });
//        }
		
		$scope.filterPageSortChangeHandler = function(evt1){
			

			$scope.userTrackerGrid = evt1.target;
			var filter = {
				pageNumber : evt1.filter.pageIndex + 1 || 1,
				pageSize : evt1.filter.pageSize || 15,
				searchText : $scope.userTrackerExDataTemp,	
				sortColumn :(evt1.filter.sorts != undefined && evt1.filter.sorts.length>0)?evt1.filter.sorts[0].sortColumn:null ,
				sort : 	 (evt1.filter.sorts!=undefined && evt1.filter.sorts.length>0)?((evt1.filter.sorts[0].isAscending)?"asc":"desc"):"asc",
						
			};

			baseRequest('api/userTracker/getFilterServerSidePagination', filter)
					.then(
							function(data) {
								$scope.userTrackerGrid.setPreservePager(true);
								$scope.userTrackerGrid
										.setDataProvider(data.data.userTrackerDTO);
								
								if (data.data.userTrackerDTO.length > 0) {
									$scope.userTrackerGrid.setTotalRecords(data.data.totalCount);
									
								} else {
									$scope.userTrackerGrid.setTotalRecords(0);
								}
								$scope.userTrackerGrid.validateNow();

							});

		
		}
		$scope.userTrackerGridCompletion = function(event) {
			$scope.userTrackerGrid = event.target;
			
             
			$scope.userTrackerGrid.setPreservePager(true);
			$scope.userTrackerGrid.setDataProvider($scope.finalData.userTrackerDTO);
                 if($scope.finData.length>0){
                	 $scope.userTrackerGrid.setTotalRecords($scope.finalData.totalCount);}else{
                		 $scope.userTrackerGrid.setTotalRecords(0);
                 }
                 $scope.userTrackerGrid.validateNow(); 
            

		};
	
		$scope.exportExcelUserTracker = function() {

			$http({
				url : 'api/UserTracker/UserTrackerExcelExportData',
				method : 'POST',
				data : $scope.userTrackerExDataTemp,
				responseType : 'arraybuffer'
			})
					.success(

							function(response) {

								var isIE = false || !!document.documentMode;
								$scope.response = response;
								var blob = new Blob(
										[ response ],
										{
											type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
										});
								if (isIE) {

									window.navigator.msSaveOrOpenBlob(blob,
											'UserTracker Report.xlsx');
								} else {

									var anchor = angular.element('<a/>');
									var blob = new Blob([ response ], {
										type : 'application/vnd.ms-excel'
									})
									var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
									anchor.css({
										display : 'none'
									});
									// Make sure it's not visible
									angular.element(document.body).append(
											anchor); // Attach to document
									anchor.attr({
										href : objectUrl,
										target : '_self',

										download : 'UserTracker Report.xlsx'
									})[0].click();

									anchor.remove();

								}

							})

		}
	
	
	
	
	
	
	$scope.clientNameAndUserNameList = function(){
		UserTrackerService.getClientListforUserTracker().then(function(response){
			
			$scope.userAndLoginList = response;
			$scope.client =$scope.userAndLoginList.ClientName;
			$scope.login=$scope.userAndLoginList.LoginName;
		});
		
	}
		
	//
	
	$scope.getUserTrackerDetails = function(){
		
		if (vm.clientNameModel != undefined) {
			$scope.selectedclientNamesTemp = vm.clientNameModel
					.map(function(element) {
						return "<" + String(element.name) + "<"
					});
		}
		if ($scope.searchLoginName != undefined) {
			$scope.selectedloginNamesTemp = $scope.searchLoginName;
					
		}
		
		var searchText = '';
		$scope.FlagForExport = false;
		searchText = "{'clientName' : '" + $scope.selectedclientNamesTemp
		+ "','loginName':'" + $scope.selectedloginNamesTemp + "'}";
		searchText = searchText.replace(/\'/g, "\"");
		searchText = searchText.replace(/\</g, "\'");
		
		$scope.userTrackerExDataTemp = searchText;
		 var fd = new FormData();
			fd.append('searchText', $scope.userTrackerExDataTemp);
			fd.append('exportFlag', 'false');
		UserTrackerService.getUserTrackerTrackerInfo(fd).then(
				function(result) {
					console.log(result);
					$scope.finalData = result;
					$scope.finData = result.userTrackerDTO;
					$scope.userTrackerGridData = {

						dataProvider : result,
						delegate : $scope

					};
					
					$timeout(function() {								
						$scope.userTrackerGrid.setPreservePager(true);
						$scope.userTrackerGrid.setDataProvider(result.userTrackerDTO);
						if (result.userTrackerDTO.length > 0) {
						$scope.userTrackerGrid.setTotalRecords(result.totalCount);
						}else{
							$scope.userTrackerGrid.setTotalRecords(0);
						}
					
						
						$scope.userTrackerGrid.validateNow();
						$scope.userTrackerGrid.rebuild();
					}, 100);

				});

		
	}
	
	$scope.resetFilter = function() {
		vm.clientNameModel = [];
		$scope.selectedclientNamesTemp = [];
		vm.loginNameModel=[];
		$scope.selectedloginNamesTemp =[];
		$scope.searchLoginName ='';
		$scope.getUserTrackerDetails();
	}
	
	
	
	$scope.clientNameAndUserNameList();

	$scope.resetFilter();
	}

})();
